import React from "react";
import {
  Grid,
  Paper,
  Divider,
  Typography,
  Button,
  Box
} from "@material-ui/core";
import { GRAY, WHITE } from "../../constants";

interface BannerProps {
  message: string;
  showDismissButton: boolean;
  handleBannerDismiss: () => void;
  timeout?: number;
  backgroundColor?: string;
  color?: string;
}

const Banner = (props: BannerProps): JSX.Element => {
  const {
    message,
    showDismissButton,
    handleBannerDismiss,
    timeout,
    backgroundColor = GRAY,
    color = WHITE
  } = props;
  if (timeout) {
    setTimeout(() => handleBannerDismiss(), timeout);
  }
  return (
    <React.Fragment>
      <Paper elevation={0} style={{ backgroundColor, color }}>
        <Box
          pt={1}
          pr={1}
          pb={1}
          pl={2}
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box flex={6}>
            <Typography style={{ textAlign: "center", marginLeft: "15%" }}>
              {message}
            </Typography>
          </Box>
          {showDismissButton && (
            <Box
              flex={1}
              p={2}
              justifyContent="flex-end"
              display="flex"
              alignItems="center"
            >
              <Button color="primary" onClick={() => handleBannerDismiss()}>
                &times;
              </Button>
            </Box>
          )}
        </Box>
      </Paper>
      <Divider />
    </React.Fragment>
  );
};

export default Banner;
